import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgWarehouse} from "~/assets/svg/warehouse.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmWarehouseIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgWarehouse id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
